'use client';

import { SessionProvider } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const pathname = usePathname();
  if (pathname?.startsWith('/word-addin')) {
    return <>{children}</>;
  }
  return <SessionProvider>{children}</SessionProvider>;
}
